import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import HTML5Backend from "react-dnd-html5-backend";
import { DragDropContext } from "react-dnd";

import { GuaranteeContainer } from "./";

class FiscalSplitFields extends React.Component {
  render() {
    const { formValues } = this.props;
    if (!formValues) {
      return null;
    }
    const splits = formValues.splits || [];
    return (
      <div className="guarantees">
        {this.props.error && (
          <div className="error-message danger">
            <FormattedMessage id={this.props.error.splitsActiveIn.messageKey} />
          </div>
        )}
        <div>
          <div className="sub-group">
            <h3>
              <FormattedMessage id="clientClasses.form.fiscalSplit.actives" />
            </h3>
            <div className="fiscal-split">
              <div className="fiscal-split-row in-split">
                <div className="heading">
                  <h6>
                    <FormattedMessage id="clientClasses.form.fiscalSplit.inOptimization" />
                  </h6>
                  <span className="employer-portion">
                    <FormattedMessage id="clientClasses.form.fiscalSplit.employerPortion" />
                  </span>
                  <span className="employer-portion">
                    <FormattedMessage id="clientClasses.form.fiscalSplit.exclude" />
                  </span>
                </div>
                <div className="content">
                  <GuaranteeContainer
                    formValues={this.props.formValues}
                    disabled={this.props.disabled}
                    id="ActiveIn"
                    list={splits.filter(
                      (clientCoverage) =>
                        clientCoverage.isActive &&
                        !clientCoverage.isOutOfOptimization
                    )}
                    valueType={formValues.valueType}
                    setWarning={this.props.setWarning}
                  />
                </div>
              </div>

              <div className="fiscal-split-row out-of-split">
                <div className="heading">
                  <h6>
                    <FormattedMessage id="clientClasses.form.fiscalSplit.outOfOptimization" />
                  </h6>
                  <span className="employer-portion">
                    <FormattedMessage id="clientClasses.form.fiscalSplit.employerPortion" />
                  </span>
                  <span className="employer-portion">
                    <FormattedMessage id="clientClasses.form.fiscalSplit.exclude" />
                  </span>
                </div>
                <div className="content">
                  <GuaranteeContainer
                    formValues={this.props.formValues}
                    disabled={this.props.disabled}
                    id="ActiveOut"
                    list={splits.filter(
                      (clientCoverage) =>
                        clientCoverage.isActive &&
                        clientCoverage.isOutOfOptimization
                    )}
                    valueType={formValues.valueType}
                    setWarning={this.props.setWarning}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sub-group">
            <div className="inactive-guarantees">
              <h3>
                <FormattedMessage id="clientClasses.form.fiscalSplit.inactives" />
              </h3>
              <div className="fiscal-split">
                <div className="fiscal-split-row">
                  <div className="heading">
                    <h6>&nbsp;</h6>
                    <span className="employer-portion">&nbsp;</span>
                  </div>
                  <div className="content">
                    <GuaranteeContainer
                      formValues={this.props.formValues}
                      disabled={this.props.disabled}
                      id="Inactive"
                      list={splits.filter(
                        (clientCoverage) => !clientCoverage.isActive
                      )}
                      setWarning={this.props.setWarning}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FiscalSplitFields.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.object,
  formValues: PropTypes.object,
  setWarning: PropTypes.func,
};

export default DragDropContext(HTML5Backend)(FiscalSplitFields);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/classes/FiscalSplitFields.js